<template>
  <div>
    <el-container class="layout-container">
      <sidebar />
      <el-main>
        <service-shortcuts />
        <router-view :key="$route.fullPath" />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import ServiceShortcuts from '@/components/ServiceShortcuts.vue'
import Cache from '@/utils/cache'

export default {
  name: 'LayoutWithMenu',
  components: { Sidebar, ServiceShortcuts },
  computed: {
    navigationEpoch() { return this.$store.state.serviceNavigation.epoch }
  },
  watch: {
    navigationEpoch: {
      immediate: true,
      handler() {
        if (Cache.get('accessToken')) this.$store.dispatch('serviceNavigation/init')
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.layout-container {
  background-color: transparent;
  padding: 10px 0 0 0;
  width: 70%;
  height: 100%;
  margin: auto;
  .el-main {
    min-width: 0;
    padding: 8px 16px 16px 16px;
  }
}
</style>
